import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=af9595d6"
import script from "./ProjectInformation.vue?vue&type=script&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports